import React from "react";

export default function Header() {
  return <div className="page-title">Recent Posts</div>;
}
